export const parseLocation = () => {
  // eslint-disable-next-line no-restricted-globals
  const l = decodeURIComponent(location.pathname);
  const match = l.match(/^\/(?:profile)\/(.*)$/i);
  if (Array.isArray(match) && match.length > 0) {
    return match[1];
  }
  return null;
};
